import {
  Button,
  IconAdd20,
  IconButton,
  IconPencil20,
} from '@lightspeed/unified-components-helios-theme/react'
import React from 'react'
import { SaleAddressModal } from '../SaleAddressModal'
import type { EditAddressButtonProps } from './EditAddressButton.type'
import { useEditAddressButtonModel } from './useEditAddressButtonModel'

export const AddOrEditAddressButton: React.FC<EditAddressButtonProps> = props => {
  const model = useEditAddressButtonModel(props)

  if (model.isDisabled) {
    return null
  }

  const button =
    model.isAddType || props.text ? (
      <Button
        aria-label={model.ariaLabel}
        appearance={model.appearance}
        customDataAttributes={{ container: { 'data-track': model.dataTrack } }}
        onClick={model.handleClick}
        prefixSlot={
          model.isAddType ? (
            <IconAdd20 aria-hidden />
          ) : (
            <IconPencil20 aria-hidden />
          )
        }
        size="medium"
        type="button"
      >
        {props.text || model.addAddressLabel}
      </Button>
    ) : (
      <IconButton
        aria-label={model.ariaLabel}
        appearance="ghost"
        customDataAttributes={{ root: { 'data-track': model.dataTrack } }}
        onClick={model.handleClick}
        size="medium"
        type="button"
      >
        <IconPencil20 aria-hidden />
      </IconButton>
    )

  return (
    <div className="uc-base">
      {button}

      {!model.isAddressModalRefactorEnabled && model.showSaleAddressModal && (
        <SaleAddressModal
          formType={props.type}
          fulfillmentDetails={model.fulfilmentDetails}
          onClose={model.handleModalClose}
          onSave={model.handleModalSave}
        />
      )}
    </div>
  )
}
